
import draggable from "vuedraggable";
import Vue from "vue";
import store from "@/store"; // store
import Task from "@/components/Taskapp.vue";
import UIkit from "uikit";

export default Vue.extend({
  name: "Tasks",
  components: {
    draggable,
    Task,
  },
  props: {
    msg: {
      type: String,
    },
  },
  data() {
    return {
      todoDeletedMsg: "Your todo has been deleted",
      taskClass:
        "uk-width-1-2 uk-card-default uk-card uk-padding-small uk-card-body  uk-box-shadow-medium",
      // todos: store.state.myTodos,
    };
  },
  created() {
    store.dispatch("get_data_from_borwser");
  },

  computed: {
    filterby() {
      return store.getters.getFilterdby;
    },
    // fetch the data
    todos: {
      get() {
        let getTodos = store.getters.getTodos;
        if (!this.filterby) return store.state.myTodos;
        return getTodos.filter((todo: any) => todo.category === this.filterby);
      },
      set(new_order_todos) {
        store.dispatch({
          type: "updateOrder",
          data: new_order_todos,
          status: "TODO",
        });
      },
    },
    progess: {
      get() {
        let getProgess = store.state.progressTodo;
        if (!this.filterby) return store.state.progressTodo;
        return getProgess.filter(
          (todo: any) => todo.category === this.filterby
        );
      },
      set(new_order_todos) {
        store.dispatch({
          type: "updateOrder",
          data: new_order_todos,
          status: "PROGRESS",
        });
      },
    },
    finished: {
      get() {
        let getFinished = store.state.finishedTodo;
        if (!this.filterby) return store.state.finishedTodo;
        return getFinished.filter(
          (todo: any) => todo.category === this.filterby
        );
      },
      set(new_order_todos) {
        store.dispatch({
          type: "updateOrder",
          data: new_order_todos,
          status: "FINISHED",
        });
      },
    },
    todoCounter() {
      return store.state.myTodos.length ?? 0;
    },
    progressCounter() {
      return store.state.progressTodo.length ?? 0;
    },
    finishedCounter() {
      return store.state.finishedTodo.length ?? 0;
    },
  },
  methods: {
    async removeTodo(todo: Object, status: String) {
      await store.dispatch({
        type: "remove_todo",
        data: todo,
        status: status,
      });
      UIkit.notification({
        message: this.todoDeletedMsg,
        pos: "bottom-left",
        status: "danger",
      });
    },
  },
});
